import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const styles = {
  container: {
    minHeight: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1.5,
    px: 3,
    textAlign: 'center',
    bgcolor: 'background.paper',
  },
  title: (theme) => ({
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightBold,
    color: 'secondary.main',
  }),
  description: (theme) => ({
    fontSize: theme.typography.pxToRem(14),
    color: 'text.secondary',
    maxWidth: 320,
  }),
};

// Full-page status layout for the standalone DocuSign signing tab.
const SigningTabLayout = ({icon, title, description}) => (
  <Box sx={styles.container}>
    {icon}
    {title && <Typography sx={styles.title}>{title}</Typography>}
    {description && <Typography sx={styles.description}>{description}</Typography>}
  </Box>
);

SigningTabLayout.propTypes = {
  description: PropTypes.string,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default SigningTabLayout;
